import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PostEmployeeRequirement from '.';

interface IPatchEmployeeRequirementProps {
  onSuccess?: (data: any) => void;
  guid?: string;
}

const usePatchEmployeeRequirements = ({
  onSuccess,
  guid,
}: IPatchEmployeeRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IEmployeeRequirementPayload) => {
      return PostEmployeeRequirement(payload, guid);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePatchEmployeeRequirements};
